/*
    Author:fanglijuan
    Time:2017-04-24
*/
"use strict";
angular.module("productManageMentNewClassifyModule", [])
    .controller("productManageMentNewClassifyCtrl", ["$scope", "$stateParams", "$validation", "$q", "$modalInstance", "trsHttpService", "initSingleSelecet", "modalDialog", "trsspliceString", "params", function($scope, $stateParams, $validation, $q, $modalInstance, trsHttpService, initSingleSelecet, modalDialog, trsspliceString, params) {
        initStatus();
        initData();

        function initStatus() {
            $scope.params = {

            };
            $scope.info = {
                title: params.ObjectId == 0 ? '新建' : '修改',
                objId: params.ObjectId
            };
            $scope.data = {
                currClassify: {},
            };
            $scope.newspaperClassifyJson = [];
        }

        function initData() {
            initAllClassifys();
        }

        /**
         * [getCurrClassify description 获取分类详细信息]
         * @return {[type]} [description]
         */
        function getCurrClassify() {
            var params = {
                "serviceid": "mlf_paperset",
                "methodname": "getCaiBianCategory",
                "ObjectId": $scope.info.objId
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.currClassify = data;
                var i = 0;
                while (i < $scope.newspaperClassifyJson.length) {
                    if ($scope.newspaperClassifyJson[i].value === data.CATEGORYORDER) {
                        $scope.newspaperClassifyJson.splice(i, 1);
                        $scope.selectedClassify = angular.copy($scope.newspaperClassifyJson[i - 1]);
                    } else {
                        i++;
                    }
                }
            });
        }
        /**
         * [initAllClassifys description 获取所有分类列表信息]
         * @return {[type]} [description]
         */
        function initAllClassifys() {
            var params = {
                "serviceid": "mlf_paperset",
                "methodname": "queryCaiBianCategory",
                "PaperId": $stateParams.paper
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                var classifyDatas = data;
                for (var key in classifyDatas) {
                    $scope.newspaperClassifyJson.push({
                        name: classifyDatas[key].CATEGORYNAME,
                        value: classifyDatas[key].CATEGORYORDER
                    });
                }
                $scope.newspaperClassifyJson.unshift({
                    name: "最前面",
                    value: -1
                });
                $scope.selectedClassify = angular.copy($scope.newspaperClassifyJson[0]);
                $scope.info.objId != 0 ? getCurrClassify() : "";
            });
        }
        //获取前一级栏目
        $scope.querySelectConfig = function() {
            $scope.data.currClassify.CATEGORYORDER = $scope.selectedClassify.value;
        };

        //保存
        $scope.save = function() {
            save().then(function() {
                $modalInstance.close("save");
            });
        };

        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        function save() {
            var deferred = $q.defer();
            $validation.validate($scope.newClassifyForm).success(function() {
                $scope.params.serviceid = "mlf_paperset";
                $scope.params.methodname = "saveCaiBianCategory";
                $scope.params.ObjectId = params.ObjectId;
                $scope.params.PaperId = $stateParams.paper;
                $scope.params.CATEGORYNAME = $scope.data.currClassify.CATEGORYNAME;
                $scope.params.CATEGORYORDER = $scope.selectedClassify.value;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    modalDialog.alertType($scope.info.title + "成功", "", "success", false, function() {});
                    deferred.resolve();
                });
            }).error(function() {
                $scope.showAllTips = true;
                modalDialog.alertType("提交失败", "请填写必填项", "error", false, function() {});
            });
            return deferred.promise;
        }
    }]);
